import { JSX } from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
} from 'react-admin';
import {
    LinearProgress,
} from '@mui/material';
import { useYearChoices } from "../../defaults/defaults";
import { useGetIndustries } from "../global-hooks/default-system-hooks";
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminCompanyCreate: () => JSX.Element = (): JSX.Element => {
    const yearChoices: { id: string, name: string }[] = useYearChoices();
    const { loadedIndustries, loadingIndustries } = useGetIndustries();
    return (
        <Create>
            <SimpleForm>
                <TextInput name="name" source="name" validate={[required()]} fullWidth />
                <SelectInput
                    name="yearEstablished"
                    source="yearEstablished"
                    choices={ yearChoices }
                    optionValue="id"
                />
                <TextInput name="vat" source="vat" fullWidth />
                <TextInput name="sicCode" source="sicCode" fullWidth />
                { (loadingIndustries) &&
                    <LinearProgress sx={ { margin: '10px 0', width: '50%' } } />
                }
                { (!loadingIndustries) &&
                    <SelectInput
                        name="industry"
                        source="industry"
                        choices={ loadedIndustries }
                        optionValue="id"
                    />
                }

                <TextInput name="companyNumber" source="companyNumber" fullWidth />
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Create>
    );
}